import { Controller } from "@hotwired/stimulus";

/**
 * GO4S — historique des conversations Juju en mode drawer.
 * Fait glisser la liste des conversations par-dessus le chat (slide-over interne).
 */
export default class extends Controller {
  toggle() {
    this.element.classList.toggle("show-history");
  }

  close() {
    this.element.classList.remove("show-history");
  }
}
